// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-m_fE","advertDetailContactItem__link":"c-m_fF"};